<template>
  <v-snackbar
    v-for="snack in getSnackbars"
    :key="snack.id"
    :model-value="true"
    :color="snack.color"
    :timeout="snack.timeout"
    style="cursor: pointer; --v-layout-right: 0px;"
    rounded="10"
    location="top right"
  >
    <span v-if="snack.message" v-on:click="clickSnackbar(snack)"> {{ snack.message }} </span>
    <span v-else-if="snack.i18n" v-on:click="clickSnackbar(snack)"> {{ $t(snack.i18n) }} </span>
    <span v-else-if="snack.replaceTCode" v-on:click="clickSnackbar(snack)">
        {{ $replaceT(snack.replaceTCode, snack.replaceTParams, snack.replaceTFallback) }}
      </span>

    <template v-slot:actions="{ attrs }">
      <v-btn
        icon
        v-bind="attrs"
        @click="closeSnackbar(snack)"
        data-cy="snackbar-close-btn"
        rounded="circle"
        width="36"
        height="36"
      >
        <v-icon tile size="small">mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { useMainStore } from '@/stores/MainStore.js'

export default {
  name: "SnackbarsComponent",
  methods: {
    closeSnackbar: function(snack) {
      const mainStore = useMainStore();
      mainStore.removeSnackbar(snack);
    },
    clickSnackbar: function(snack) {
      if (snack.showLimitsOnClick) {
        this.showLimitsOnClick(snack);
      }

      if (snack.showPodAssetsOnClick) {
        this.showPodAssetsOnClick(snack);
      }
    },

    showLimitsOnClick: function(snack) {
      if (!this.$canControlTenantConfig()) {
        return;
      }

      const mainStore = useMainStore();
      mainStore.showSubscriptionContactDialog();
      this.closeSnackbar(snack);
    },
    showPodAssetsOnClick(snack) {
      this.$router.push(`/pod/${snack.pod.id}?menu=assets`);
      this.closeSnackbar(snack);
    },
  },
  computed: {
    getSnackbars: function() {
      const mainStore = useMainStore();
      return mainStore.getSnackbars;
    },
  }
}
</script>

<style lang="scss" scoped>
.v-theme--light .v-btn {
  color: rgb(var(--v-theme-surface));
}
</style>
